export default "__VITE_ASSET__54a123c4__"